import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
/**
 * Provides AES-256 (CBC mode) encryption and decryption utilities using CryptoJS
 * with the application's configured encryption key.
 */
export class EncryptDecryptService {
  private key = CryptoJS.enc.Utf8.parse(environment.ENCRYPTION_KEY);
  private iv = CryptoJS.enc.Utf8.parse(environment.ENCRYPTION_KEY);

  constructor() {}

  /**
   * Encrypts a plain-text value using AES-256 CBC with PKCS7 padding.
   * @param text The plain-text value to encrypt.
   * @returns The Base64-encoded cipher text string.
   */
  encryptUsingAES256(text: any): string {
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  /**
   * Decrypts a Base64-encoded AES-256 CBC cipher text back to plain text.
   * @param decString The encrypted cipher text string to decrypt.
   * @returns The decrypted plain-text string.
   */
  decryptUsingAES256(decString: string): string {
    const decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
